import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate, currencyFormat, stdWeekDayInd } from 'utilities/common';

export const DetailContract = ({ data, privilege }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Contract.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section className="pt-2 mb-3" id="shipment">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Kontrak Order
        </div>
      )}

      <div className="row mb-4">
        <div className="col-12">
          {StateLoading || !data ? (
            dummy?.map((d, i) => (
              <ListHorizontal
                key={i}
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            ))
          ) : (
            <>
              {data?.service_type && (
                <ListHorizontal
                  title="Tipe Layanan"
                  content={data?.service_type?.name}
                />
              )}
              <ListHorizontal
                title="Periode"
                content={
                  <span>
                    {formatDate(data?.periode_start_at, 'DD/MM/YYYY')} -{' '}
                    {formatDate(data?.periode_end_at, 'DD/MM/YYYY')}
                  </span>
                }
              />
              {
                data?.repeat_type && (
                  <ListHorizontal
                    title="Ulangi"
                    content={
                      <span>
                        {data?.repeat_type.replace('every_day', 'Setiap Hari')} {data?.repeat_day?.length > 0 && `(${stdWeekDayInd(data?.repeat_day)})`}
                      </span>
                    }
                  />
                )
              }
              {privilege && (
                <ListHorizontal
                  title="Harga"
                  content={currencyFormat(data?.price, 'IDR')}
                />
              )}
              <ListHorizontal title="Dibuat Oleh" content={data?.created_by} />
              <ListHorizontal
                title="Dibuat Tanggal"
                content={formatDate(data?.created_at)}
              />
            </>
          )}
        </div>
      </div>
    </section>
  );
};
